import MessageBanner from 'LuxKit/Banners/MessageBanner'
import { useCallback } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { undoRegenerateDayAi } from 'tripPlanner/api'
import { invalidateTrip } from 'tripPlanner/hooks/api/common'
import TextLink from 'LuxKit/TextLink'
import LineCheckIcon from 'LuxKit/Icons/line/LineCheckIcon'
import Group from 'components/utils/Group'

interface ReplanFeedbackProps {
  tripId: string
  date: string
  onUndo: () => void
}

function ReplanFeedback({ tripId, date, onUndo }: ReplanFeedbackProps) {
  const intl = useIntl()
  const queryClient = useQueryClient()

  const undoRegenerateDayMutation = useMutation({
    mutationFn: () => undoRegenerateDayAi({ tripId, date }),
    onSuccess: () => {
      invalidateTrip(queryClient, tripId)
      onUndo()
    },
  })

  const handleUndoRegenerateDay = useCallback(() => {
    undoRegenerateDayMutation.mutate()
  }, [undoRegenerateDayMutation])

  return (
    <MessageBanner
      kind="success"
      align="center"
      icon={<LineCheckIcon />}
      secondaryActionButtonProps={{
        children: intl.formatMessage({
          id: 'DFBgSDcIvvktrMmRWZeZ',
          defaultMessage: 'Dismiss',
          description: 'Action button to dismiss the replan feedback banner',
        }),
        onClick: onUndo,
      }}
    >
      <Group direction="horizontal" gap={12}>
        <FormattedMessage
          id="2YECIJEuGbV38eIBhTlN"
          defaultMessage="Your day has been replanned. <undoLink>Undo</undoLink>"
          description="Success message after replanning a day with undo link"
          values={{
            undoLink: (chunks) => (
              <TextLink onClick={handleUndoRegenerateDay}>{chunks}</TextLink>
            ),
          }}
        />
      </Group>
    </MessageBanner>
  )
}

export default ReplanFeedback
